import List from "@/components/list";
import router from "@/router";
import Bus from "./Bus";
const Table = args => {
  const RCSelectionChange = args.listeners["selection-change"] || function() {};
  //编辑
  function handleUpdate({ row }) {
    Bus.$emit("ReceiveMessage", Object.assign({}, row));
  }
  //删除
  function handleDelete({ row }) {
    Bus.$emit("classWorkDelete", row);
  }
  //学员作业
  function studentWorkList({ row }) {
    router.push({
      path: "/onlineClass/teaching/classWork/studentWork",
      query: row
    });
  }
  //附件下载
  function handleDownloadWork({ row }) {
    Bus.$emit("downloadWork", row);
  }
  const Deal = ({ props: { vo } }) => {
    const dealConf = [
      ["icon-edit", "编辑", () => handleUpdate(vo), "work:update"],
      ["icon-delete", "删除", () => handleDelete(vo), "work:delete"],
      [
        "icon-user-list",
        "学员作业",
        () => studentWorkList(vo),
        "studentWork:page"
      ]
    ];
    return (
      <div class="deal-group">
        {dealConf.map(item => (
          <el-tooltip content={item[1]} placement="top" v-permission={item[3]}>
            <i class={item[0]} onClick={item[2]}></i>
          </el-tooltip>
        ))}
      </div>
    );
  };
  const AllowRemedy = ({ props: { vo } }) => {
    const work = vo.row;
    if (work.allowRemedy == 1) {
      const remedyContent = `补交截止时间：${work.remedyDeadline}，补交获得学分：${work.remedyCredit}`;
      return (
        <el-popover
          placement="top-start"
          width="230"
          trigger="hover"
          content={remedyContent}
        >
          <el-button slot="reference" size="small" type="text">
            {work.allowRemedyName}
          </el-button>
        </el-popover>
      );
    } else {
      return <div>{work.allowRemedyName}</div>;
    }
  };
  const AccountTableConfig = [
    {
      label: "作业名称",
      prop: "workName",
      minWidth: "120"
    },
    {
      label: "学分",
      prop: "workCredit",
      minWidth: "120"
    },
    {
      label: "附件",
      prop: "attachmentName",
      minWidth: "120",
      showOverflowTooltip: true,
      render: vo => (
        <el-button
          class="no-padding"
          size="small"
          type="text"
          v-permission="work:download"
          onClick={() => handleDownloadWork(vo)}
        >
          {vo.row.attachmentName}
        </el-button>
      )
    },
    {
      label: "是否必修",
      prop: "isRequiredName",
      minWidth: "120"
    },
    {
      label: "允许补交",
      prop: "allowRemedyName",
      minWidth: "120",
      render: vo => <AllowRemedy vo={vo} />
    },
    {
      label: "完成情况",
      prop: "finishSituation",
      minWidth: "120"
    },
    {
      label: "布置时间",
      prop: "createDate",
      minWidth: "130",
      showOverflowTooltip: true
    },
    {
      label: "上传截止时间",
      prop: "deadline",
      minWidth: "130",
      showOverflowTooltip: true
    },
    {
      label: "操作",
      minWidth: "140",
      fixed: "right",
      render: vo => <Deal vo={vo} />
    }
  ];
  return (
    <div>
      <List
        {...args}
        empty-text="还没布置过作业哦"
        onSelectionChange={RCSelectionChange}
        talbeCols={AccountTableConfig}
      />
    </div>
  );
};

export default Table;
